import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [changeRequired, setChangeRequired] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { login, changePassword } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = "Scan Loom | Sign In";
    const ssoError = searchParams.get("sso_error");
    if (ssoError) setError(`SSO error: ${ssoError}`);
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    try { await login(email, password); navigate("/"); }
    catch (err) {
      if (err.response?.status === 403 && err.response?.data?.mustChangePassword) {
        setChangeRequired(true);
      } else {
        setError(err.response?.data?.error || "Login failed");
      }
    }
    finally { setIsSubmitting(false); }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) { setError("Passwords do not match"); return; }
    setIsSubmitting(true);
    try { await changePassword(email, password, newPassword); navigate("/"); }
    catch (err) { setError(err.response?.data?.error || "Password change failed"); }
    finally { setIsSubmitting(false); }
  };

  return (
    <div className="tl-login-bg">
      <div className="tl-login-card">
        <img src="/assets/scan-loom_logo_lg.png" alt="Scan Loom" style={{ width: 135, marginBottom: 12 }} />
        <br />
        <img src="/assets/scan-loom_text_lg.png" alt="Scan Loom" style={{ width: 250, marginBottom: 8 }} />
        <p className="subtitle">{changeRequired ? "Set a new password to continue" : "Sign in to continue"}</p>
        {error && <div className="alert alert-danger py-2" style={{ textAlign: "left", fontSize: "13px" }}>{error}</div>}
        {changeRequired ? (
        <form onSubmit={handleChangePassword} style={{ textAlign: "left" }}>
          <div className="mb-3">
            <label className="tl-form-label">New Password</label>
            <input type="password" className="form-control tl-form-control" placeholder="At least 8 characters" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={8} autoFocus />
          </div>
          <div className="mb-3">
            <label className="tl-form-label">Confirm New Password</label>
            <input type="password" className="form-control tl-form-control" placeholder="Re-enter new password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} />
          </div>
          <button type="submit" className="btn btn-tl-primary w-100 py-3" style={{ fontSize: "16px", borderRadius: "10px" }} disabled={isSubmitting}>
            {isSubmitting ? "Saving..." : "Set Password & Sign In"}
          </button>
        </form>
        ) : (
        <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
          <div className="mb-3">
            <label className="tl-form-label">Email</label>
            <input className="form-control tl-form-control" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="mb-3">
            <label className="tl-form-label">Password</label>
            <input type="password" className="form-control tl-form-control" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="btn btn-tl-primary w-100 py-3" style={{ fontSize: "16px", borderRadius: "10px" }} disabled={isSubmitting}>
            {isSubmitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
        )}
        {!changeRequired && (<>
        <div className="d-flex align-items-center my-3">
          <hr className="flex-grow-1" /><span className="mx-3 text-muted small">OR</span><hr className="flex-grow-1" />
        </div>
        <button className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2 py-2" onClick={() => window.location.href = "/auth/sso"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Sign in with Microsoft
        </button>
        </>)}
        <p className="text-muted small mt-4 mb-0">Copyright &copy; 2026 ThinkClean</p>
      </div>
    </div>
  );
};

export default LoginPage;
